import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lg:grid lg:grid-cols-3 gap-[25px]" }
const _hoisted_2 = { class: "lg:col-span-3" }

import { ref } from "vue";
import CalendarContent from "@/components/Apps/Calendar/CalendarContent.vue";
import AddEventModal from "@/components/Apps/Calendar/AddEventModal.vue";
import EditEventModal from "@/components/Apps/Calendar/EditEventModal.vue";
import EditWorkingHoursModal from "@/components/Apps/Calendar/EditWorkingHoursModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarPage',
  setup(__props) {

const editEventModalRef = ref<any>(null);
const showWorkingHoursModal = ref(false);

function openEditEventModal(event: any) {
  if (editEventModalRef.value) {
    editEventModalRef.value.openModal(event);
  }
}

function openWorkingHoursModal() {
  showWorkingHoursModal.value = true;
}

function closeWorkingHoursModal() {
  showWorkingHoursModal.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(CalendarContent, {
          onEventClick: openEditEventModal,
          onEditWorkingHours: openWorkingHoursModal
        })
      ])
    ]),
    _createVNode(AddEventModal),
    _createVNode(EditEventModal, {
      ref_key: "editEventModalRef",
      ref: editEventModalRef
    }, null, 512),
    _createVNode(EditWorkingHoursModal, {
      "is-active": showWorkingHoursModal.value,
      onClose: closeWorkingHoursModal
    }, null, 8, ["is-active"])
  ], 64))
}
}

})